module.exports = __webpack_public_path__ + "static/fonts/iconfont.c327b3bb.ttf";